import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Routewrapper } from './route/index';
import './styles/index.css';
import './styles/toast-styles.css';
import './styles/responsive.css';
import './services/i18n';
import { Provider } from 'react-redux';
import store from './redux/store';
import { FeatureFlagProvider } from './context/FeatureFlagContext';

// interceptors for all request and reponse
import('./services/api.interceptors').then(({ executeInterceptors }) => executeInterceptors());

ReactDOM.render(
  <Provider store={store}>
    <FeatureFlagProvider>
      <Routewrapper />
    </FeatureFlagProvider>
  </Provider>,
  document.getElementById('root')
);
